import { render } from "./DataMapperInvocations.vue?vue&type=template&id=6837e590&scoped=true"
import script from "./DataMapperInvocations.vue?vue&type=script&lang=js"
export * from "./DataMapperInvocations.vue?vue&type=script&lang=js"

import "./DataMapperInvocations.vue?vue&type=style&index=0&id=6837e590&scoped=true&lang=css"
import "./DataMapperInvocations.vue?vue&type=style&index=1&id=6837e590&lang=scss"
import "./DataMapperInvocations.vue?vue&type=style&index=2&id=6837e590&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6837e590"]])

export default __exports__